import { List, ListProps } from "@p0security/ui";
import classNames from "classnames";

/** A list that scrolls internally once it grows past a few rows, so a node's
 * detail panel stays a predictable height however much it has to show.
 */
export const DisplayList = <T,>({ className, ...props }: ListProps<T>) => (
  <List<T>
    className={classNames("max-h-[280px] overflow-y-auto pr-[10px]", className)}
    {...props}
  />
);
